import React, { useState } from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Typography from "@material-ui/core/Typography/Typography";
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => {
    return {
        root: {
            flex: '0 0 100%',
            position: 'relative'
        },
        rootMobile: {
            marginLeft: 10,
            marginRight: 5,
            width: '100%',
            position: 'relative',
            flex: 'auto',
        },
        path: {
            marginTop: 20
        },
        pathItem: {
            padding: '0 5px',
            color: '#3849a4',
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline',
            }
        },
        first: {
            paddingLeft: 0
        },
        h1: {
            marginTop: 5,
            marginBottom: 10,
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            lineHeight: 1.5,
            fontSize: '1.9rem',
            letterSpacing: '0.0075em',
            fontWeight: 500,
            color: '#444',
            display: 'inline-block'
        },
        h1Mobile: {
            fontSize: '1.2rem'
        },
        zipCodeIcon: {
            marginLeft: 20,
            marginTop: -4,
            color: '#444',
            fontSize: '1.5rem',
            wposition: 'absolute',
        },
        zipCodeIconMobile: {
            marginLeft: 10,
            marginTop: 0,
            color: '#444',
            fontSize: '1rem',
        },
        zipCode: {
            display: 'inline-block',
            fontSize: '1.2rem',
            color: '#444',
            marginLeft: 5,
        },
        zipCodeMobile: {
            marginTop: 0,
            marginLeft: 0,
            fontSize: '.9rem'
        },
        backIcon: {
            position: 'absolute',
            marginTop: 6,
            ['@media (max-width:700px)']: {
                marginTop: 3,
            },
            fontSize: '1rem',
        },
        backLink: {
            paddingLeft: 20
        },
        actions: {
            position: 'absolute',
            right: 0,
            display: 'inline-block',
            maxHeight: 20
        },
        sideContent: {
            position: 'absolute',
            right: 0,
            bottom: 20,
            ['@media (max-width:1200px)']: {
                right: 5,
            },
            ['@media (max-width:700px)']: {
                bottom: 15,
                right: 0,
            },
        },
        withSideContent: {
            marginRight: 182,
            ['@media (max-width:700px)']: {
                marginRight: 100,
            },
        }
    }});

export default function BaseHeader(props) {

    const classes = useStyles();

    const filter = props.filter;

    const handleItemExit = (e) => {
        e.preventDefault();
        props.handleItemExit(e);
    };

    return (

        <div className={clsx(classes.root, props.isMobile ? classes.rootMobile : null)}>
            <div className={classes.path}>
                <Typography>
                    {props.exitUrl
                        ? <>
                            <a className={clsx(classes.pathItem, classes.first)} href={props.exitUrl}
                               onClick={handleItemExit}><ArrowBackIosOutlinedIcon className={classes.backIcon}/></a>
                            <a className={clsx(classes.pathItem, classes.backLink)} href={props.exitUrl}
                             onClick={handleItemExit}>Back to results</a></>
                        : <>
                            <a className={clsx(classes.pathItem, classes.first)} href="/">Home</a>
                            /<a className={classes.pathItem} href="/used-cars">Used Cars</a>
                        </>}

                    {props.path ? props.path.map(item => {
                        return item ? <>/<a className={classes.pathItem} href={item.url}>{item.label}</a></> : null
                    }) : null}
                    {props.location ? <>
                        <LocationOnOutlinedIcon className={clsx(classes.zipCodeIcon, props.isMobile ? classes.zipCodeIconMobile: null)}/>
                        <Typography className={clsx(classes.zipCode, props.isMobile ? classes.zipCodeMobile : null)}>{props.location}</Typography>
                        </> : null}
                    {props.actions ? <div className={classes.actions}>{props.actions}</div> : null}
                </Typography>
            </div>
            <div className={classes.header}>
                <h1 className={clsx(
                    classes.h1,
                    props.isMobile ? classes.h1Mobile : null,
                    props.sideContent ? classes.withSideContent : null
                )}>{props.header}</h1>
            </div>
            {props.sideContent ? <div className={classes.sideContent}>{props.sideContent}</div> : null}
        </div>
    );
}


